import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-grids";
import { Observable, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";

import { GetHandbookBO, HandbookBO } from "./handbook.model";
// import { onBoardingtemplateBO } from "./agreement-template.model";
@Injectable({
  providedIn: 'root'
})

export class HandBookService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public errorService: ErrorService) {
    super();
  }

  public executeClient(state: GetHandbookBO): void {
    this.getTemplateListClient(state).subscribe(x => super.next(x));
  }
  getTemplateListClient(state?: GetHandbookBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Handbook/GetHandBookList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }

  public executeEmployee(state: GetHandbookBO): void {
    this.getTemplateListEmployee(state).subscribe(x => super.next(x));
  }

  getTemplateListEmployee(state?: GetHandbookBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Handbook/GetHandBookList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['totalCount']
          }
      ))
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
 
  GetAllEmployeeForAgencyHandBook(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Employee/GetEmployeesbasedOnAgency?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SaveHandbook(saveLogin: HandbookBO): Observable<any> {
    let url = "api/Handbook/saveHandbook?";
    return this.http.post(url, saveLogin, { observe: 'response',responseType: "text"  }).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
}

DeleteHandBook(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Handbook/DeleteHandbook?";
  return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

// GetViewHandBook(paramsData: URLSearchParams): Observable<any> {
//   let url = "api/HandBook/getHandbookDocBase64?";
//   return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
//     map(data => data.body),
//     catchError(this.errorService.handleError)
//   )
// }

GetViewHandBook(params, url): Observable<any> {
  return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
  );
}

}
